import { render, staticRenderFns } from "./SubscriptionPage.vue?vue&type=template&id=70327581&scoped=true&"
import script from "./SubscriptionPage.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPage.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPage.vue?vue&type=style&index=0&id=70327581&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70327581",
  null
  
)

export default component.exports